import React from 'react';
import styled from 'styled-components';

import { RichText } from 'components/Text';
import { textStyles } from 'theme';

export const SignUpBlockHeadline = styled(
  ({ text, isPageHeader }: { text: string; isPageHeader: boolean }) => (
    <RichText
      dangerouslySetInnerHTML={{
        __html: `<${isPageHeader ? 'h1' : 'h2'}>${
          text ? text.replace(/<(\/?)(p|h1|h2)>/g, '<$1span>') : ''
        }</${isPageHeader ? 'h1' : 'h2'}>`,
      }}
    />
  )
)`
  && {
    h1,
    h2 {
      ${textStyles.h2};
    }
  }
`;
